import React from 'react';
import styled from '@emotion/styled';
import { SideNavConsumer } from '../context/SideNavContext';
import ChevronIcon from './icons/ChevronIcon';

const ToggleButton = styled.button`
  display: flex;
  justify-content: flex-end;
  border: none;
  border-bottom: 1px solid #5ca0d3;
  width: 100%;
  background: none;
  color: inherit;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
`;

const SvgWrapper = styled.div<{ open: boolean }>`
  svg {
    margin: 0.7rem 0;
    margin-right: 1rem;
    width: 1rem;
    height: 0.7rem;
    path {
      fill: #c8dff0;
    }

    transform: ${s => (s.open ? 'rotate(90deg)' : 'rotate(-90deg)')};
  }
`;

const NavToggle = () => {
  return (
    <SideNavConsumer>
      {({ state, toggleSideNav }) => (
        <ToggleButton onClick={toggleSideNav}>
          <SvgWrapper open={state.isSideNavOpen}>
            <ChevronIcon />
          </SvgWrapper>
        </ToggleButton>
      )}
    </SideNavConsumer>
  );
};

export default NavToggle;
